import { render, staticRenderFns } from "./poderi-boscarelli.vue?vue&type=template&id=e67e68c2&scoped=true"
import script from "./poderi-boscarelli.vue?vue&type=script&lang=js"
export * from "./poderi-boscarelli.vue?vue&type=script&lang=js"
import style0 from "./poderi-boscarelli.vue?vue&type=style&index=0&id=e67e68c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67e68c2",
  null
  
)

export default component.exports